export enum WidgetType {
  LINK = 'link-widget',
  TEXT = 'text-widget',
}
